<template lang="pug">
    v-app
        div.main-div-container
            router-view
</template>

<script>
export default {
    name: 'app',
    props: {},
    data: function() {
        return {
        }
    },
    computed: {},
    methods: {},
    watch: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    .main-div-container {
        height: 100%;
    }
    .rounded-0 {
        border-radius: 0 !important;
    }
</style>